import cn from 'classnames'
import { FC, useCallback } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { FormNumberInput, useGetFormDataField } from 'cng-common/features/form'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../translations'

import { tooltipMessage } from './configs'

import styles from './RetailInfoEditMode.module.scss'

interface IRetailInfoEditModeProps {
  employersCount: Nullable<number>
  salesCount: Nullable<number>
}

export const RetailInfoEditMode: FC<IRetailInfoEditModeProps> = ({
  employersCount,
  salesCount,
}) => {
  const [formEmployersCount] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.employersCount
  )
  const [formSalesCount] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.salesCount
  )

  const shouldShowCompletenessWarning = useCallback((currentValue: Nullable<number>) => {
    return currentValue === null
  }, [])

  const tooltipRender = useCallback(() => {
    return <>{tooltipMessage}</>
  }, [])

  const formEmployersCountTooltipCondition =
    shouldShowCompletenessWarning(formEmployersCount) && !formEmployersCount
  const formSalesCountTooltipCondition =
    shouldShowCompletenessWarning(formSalesCount) && !formSalesCount

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <Tooltip disabled={!formEmployersCountTooltipCondition} tipContent={tooltipRender}>
            <FormNumberInput
              formKey={PARTNER_BASIC_INFO_FORM_KEY}
              field={partnerBasicInfoFields.employersCount}
              label={TRANSLATION_KEYS.employersCountLabel}
              defaultValue={employersCount}
              className={cn({ [styles.warning]: formEmployersCountTooltipCondition })}
            />
          </Tooltip>
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <Tooltip disabled={!formSalesCountTooltipCondition} tipContent={tooltipRender}>
            <FormNumberInput
              formKey={PARTNER_BASIC_INFO_FORM_KEY}
              field={partnerBasicInfoFields.salesCount}
              label={TRANSLATION_KEYS.salesCountLabel}
              defaultValue={salesCount}
              className={cn({ [styles.warning]: formSalesCountTooltipCondition })}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
